import React from 'react';
export function ContactBand() {
  return <section id="contact" className="bg-au-green py-16" data-id="element-70">
      <div className="max-w-7xl mx-auto px-4 md:px-8 text-center" data-id="element-71">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-6" data-id="element-72">
          Partner With Us for Africa's Future
        </h2>
        <p className="text-green-50 text-lg max-w-2xl mx-auto mb-8" data-id="element-73">
          We welcome collaboration with international organizations, private
          sector partners, and development agencies to achieve the goals of
          Agenda 2063.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-74">
          <a href="#" className="bg-au-gold text-au-navy px-8 py-3 rounded font-bold hover:bg-yellow-400 transition-colors shadow-sm" data-id="element-75">
            Contact Partnerships Team
          </a>
          <a href="#" className="bg-transparent border-2 border-white text-white px-8 py-3 rounded font-bold hover:bg-white hover:text-au-green transition-colors" data-id="element-76">
            Subscribe to Updates
          </a>
        </div>
      </div>
    </section>;
}